// Details-view cache tuning. Change the TTL here.

/**
 * How long a cached details-view record stays valid. A plate scanned again
 * within this window renders from the browser DB without hitting the network;
 * older slices are re-fetched (and the expired copy garbage-collected).
 */
export const VEHICLE_CACHE_MAX_AGE_DAYS = 90;

export const VEHICLE_CACHE_MAX_AGE_MS = VEHICLE_CACHE_MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
